import requestAction from '../../utils/requestAction'

export const fetchCtrlPreorders = (params?: string) =>
  requestAction('PREORDER_CTRL_LIST', params)(`preorders`, 'GET')
